import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createEmpleado, updateEmpleado, getEmpleadoById } from "../services/api";

export default function EmpleadoForm() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    nombre: "",
    telefono: "",
    ubicacion: "",
    oficina: "",
    sueldo: "",
    rol: "",
    area: "",
    estatus: "ACTIVO",
    correo: "",
    fotoUrl: "",
    jefeId: "",
  });

  useEffect(() => {
    const cargar = async () => {
      if (!id) return;

      try {
        setLoading(true);
        const res = await getEmpleadoById(id);
        const data = res.data || {};

        setForm({
          nombre: data.nombre || "",
          telefono: data.telefono || "",
          ubicacion: data.ubicacion || "",
          oficina: data.oficina || "",
          sueldo: data.sueldo || "",
          rol: data.rol || "",
          area: data.area || "",
          estatus: data.estatus || "ACTIVO",
          correo: data.correo || data.email || "",
          fotoUrl: data.fotoUrl || "",
          jefeId: data.jefeId || "",
        });
      } catch (err) {
        console.error("Error al cargar empleado:", err);
        alert("No se pudo cargar el empleado.");
      } finally {
        setLoading(false);
      }
    };

    cargar();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const guardar = async () => {
    if (!form.nombre.trim()) return alert("Captura el nombre del empleado.");
    if (!form.rol.trim()) return alert("Captura el rol.");
    if (!form.area.trim()) return alert("Captura el área.");

    const payload = {
      ...form,
      sueldo: form.sueldo === "" ? "" : Number(form.sueldo),
    };

    try {
      setLoading(true);

      if (id) {
        await updateEmpleado(id, payload);
      } else {
        await createEmpleado(payload);
      }

      navigate("/empleados");
    } catch (err) {
      console.error("Error al guardar empleado:", err);
      alert("No se pudo guardar el empleado.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-black text-slate-950">
            {id ? "Editar empleado" : "Agregar empleado"}
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Captura la información operativa del empleado.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <Input label="Nombre *" name="nombre" value={form.nombre} onChange={handleChange} />
            <Input label="Teléfono" name="telefono" value={form.telefono} onChange={handleChange} />
            <Input label="Correo" name="correo" value={form.correo} onChange={handleChange} />
            <Input label="Ubicación" name="ubicacion" value={form.ubicacion} onChange={handleChange} />
            <Input label="Oficina" name="oficina" value={form.oficina} onChange={handleChange} />
            <Input label="Rol *" name="rol" value={form.rol} onChange={handleChange} />
            <Input label="Área *" name="area" value={form.area} onChange={handleChange} />
            <Input label="Sueldo" name="sueldo" type="number" value={form.sueldo} onChange={handleChange} />
            <Input label="URL de foto" name="fotoUrl" value={form.fotoUrl} onChange={handleChange} />
            <Input label="ID jefe directo" name="jefeId" value={form.jefeId} onChange={handleChange} />

            <div>
              <label className="block text-sm font-bold text-slate-700 mb-2">
                Estatus
              </label>
              <select
                name="estatus"
                value={form.estatus}
                onChange={handleChange}
                className="w-full h-12 rounded-xl border border-slate-200 bg-slate-50 px-4 outline-none focus:border-indigo-500"
              >
                <option value="ACTIVO">ACTIVO</option>
                <option value="INACTIVO">INACTIVO</option>
              </select>
            </div>
          </div>

          <div className="mt-8 flex justify-end gap-3">
            <button
              type="button"
              onClick={() => navigate("/empleados")}
              className="px-6 py-3 rounded-xl bg-slate-200 text-slate-900 font-black"
            >
              Cancelar
            </button>

            <button
              type="button"
              onClick={guardar}
              disabled={loading}
              className="px-6 py-3 rounded-xl bg-indigo-800 text-white font-black disabled:opacity-50"
            >
              {loading ? "Guardando..." : id ? "Actualizar empleado" : "Guardar empleado"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Input({ label, name, value, onChange, type = "text" }) {
  return (
    <div>
      <label className="block text-sm font-bold text-slate-700 mb-2">
        {label}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className="w-full h-12 rounded-xl border border-slate-200 bg-slate-50 px-4 outline-none focus:border-indigo-500"
      />
    </div>
  );
}